<template>
  <div v-if="comment" class="body-1 block whitespace-pre-line">
    <p ref="textRef" :class="clampedClass">
      {{ comment }}
    </p>

    <RevLink v-if="isTextClamped" class="mt-2" @click="onToggleText">
      {{ toggleTextLabel }}
    </RevLink>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevLink } from '@ds/components/Link'

import translations from '../ReviewDisplay.translations'

const props = withDefaults(
  defineProps<{
    comment: string
    tracking?: Record<string, unknown>
    forceExpand?: boolean
  }>(),
  { forceExpand: false, tracking: () => ({}) },
)
const i18n = useI18n()
const { trackClick } = useTracking()

const isExpanded = ref(false)
const textRef = ref<HTMLElement>()

const clampedClass = computed(() => {
  if (isExpanded.value || props.forceExpand) return ''

  return 'line-clamp-[6] md:line-clamp-5'
})

const isTextClamped = computed(() => {
  if (!textRef.value || props.forceExpand) return false

  return textRef.value.scrollHeight > textRef.value.clientHeight
})

const toggleTextLabel = computed(() =>
  isExpanded.value ? i18n(translations.showLess) : i18n(translations.showMore),
)

function onToggleText() {
  isExpanded.value = !isExpanded.value

  trackClick({
    ...props.tracking,
    name: isExpanded.value ? 'see_more' : 'see_less',
  })
}

watch(
  () => props.forceExpand,
  (newValue) => {
    isExpanded.value = newValue
  },
  { immediate: true },
)
</script>
